export const TABLE_HEADERS = [
  {
    header: 'Registrations',
    id: 'registrations',
  },
  {
    header: 'FillProfiles',
    id: 'fillProfiles'
  },
  {
    header: 'Confirmed',
    id: 'emailConfirmed',
  },
  {
    header: 'Posted',
    id: 'posted',
  },
  {
    header: 'SMS4',
    id: 'sms4Plus35',
    siteIds: [37, 69],
  },
  {
    header: 'Online (min/user) ',
    id: 'online',
  },
  {
    header: 'Sales',
    id: 'sales'
  },
  {
    header: 'FTD',
    id: 'ftd'
  },
  {
    header: 'Turnover',
    id: 'turnover'
  },
  {
    header: 'Investment',
    id: 'investment'
  },
  {
    header: 'Profit',
    id: 'profit'
  },
  {
    header: 'ROI',
    id: 'roi'
  },
]

const renderCell = (condition, content) => {
  return {
    condition,
    content,
  }
}

export const renderCells = (row, tableConfig, choosedSiteId) => [
  renderCell(!tableConfig.includes("registrations"), row.registration),
  renderCell(!tableConfig.includes("fillProfiles"), row.fillProfile),
  renderCell(!tableConfig.includes("emailConfirmed"), row.emailConfirmed),
  renderCell(!tableConfig.includes("posted"), row.posted),
  renderCell(
    (choosedSiteId === 37 || choosedSiteId === 69) &&
      !tableConfig.includes("sms4Plus35"),
    row.sms4Plus35
  ),
  renderCell(!tableConfig.includes("online"), Math.floor(row.online)),
  renderCell(!tableConfig.includes("sales"), row.sales),
  renderCell(!tableConfig.includes("ftd"), row.ftd),
  renderCell(!tableConfig.includes("turnover"), row.turnover),
  renderCell(!tableConfig.includes("investment"), row.investment),
  renderCell(!tableConfig.includes("profit"), (row.turnover - row.investment).toFixed(2)),
  renderCell(!tableConfig.includes("roi"), (row.turnover / row.investment).toFixed(2)),
]